const table = [
    {
        prop: 'code',
        label: 'Código',
        minWidth: 150
    },
    {
        prop: 'name',
        label: 'Nombre',
        minWidth: 150
    },
    {
        prop: 'description',
        label: 'Descripción',
        minWidth: 150
    },
    {
        prop: 'start_date',
        label: 'Fecha de Inicio',
        minWidth: 150
    },
    {
        prop: 'finish_date',
        label: 'Fecha de Terminación',
        minWidth: 150
    },
]
export default table
